export default {
  getXeroContact: (state) => state.xeroContact,
};
